var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoaderImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-280 -260 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "plane"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.6619 27.6549L17.5353 24.2416C15.9109 24.0881 14.3471 24.9002 13.5382 26.3173C12.2565 28.5629 13.3166 31.4211 15.7525 32.288L42.6433 41.8573L29.0765 59.3443C28.987 59.4597 28.93 59.5898 28.904 59.7237L17.8296 59.7573C16.4867 59.7614 15.3104 60.658 14.9506 61.9518C14.5254 63.4805 15.3652 65.0758 16.8661 65.5905L29.715 69.9975L38.7442 79.9604C39.7185 81.0355 41.3949 81.0741 42.4178 80.0451C43.1727 79.2857 43.3685 78.1336 42.9069 77.1673L38.0105 66.9182L51.9768 49.5692L69.3081 73.7172C70.8157 75.8178 73.8558 76.0447 75.6585 74.1912C76.7962 73.0215 77.1434 71.294 76.546 69.7756L63.1402 35.7019L74.1552 22.0191C76.1084 19.5929 76.0203 16.1099 73.9469 13.7855C71.2971 10.8148 66.6019 10.9758 64.1617 14.1211L53.6619 27.6549Z",
    fill: "#FFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderImage);
export default __webpack_public_path__ + "static/media/LoaderImage.7a48f5ef47dbd710b4f684b0435a470e.svg";
export { ForwardRef as ReactComponent };